<template>
	<div class="drag-drop">
		<SlickList
			v-if="list.length"
			v-model="selectedModel"
			lock-axis="y"
			:append-to="appendTo"
			:helper-class="helperClass"
			class="drag-drop__list"
			@input="$emit('change', $event)"
		>
			<SlickItem
				v-for="(item, idx) in selectedModel"
				:key="item.id"
				:index="idx"
				class="drag-drop__item"
			>
				<p class="drag-drop__item-name" v-text="item.value" />
				<button
					class="btn-delete--only-icon drag-drop__delete-button"
					@click="deleteItem(item)"
				/>
			</SlickItem>
		</SlickList>
		<p
			v-else
			class="drag-drop__noitem"
			v-text="
				'좌측에서 성분을 검색 후 검색된 결과를 클릭하면 성분이 추가됩니다.'
			"
		/>
	</div>
</template>
<script>
	import { SlickList, SlickItem } from 'vue-slicksort';

	export default {
		name: 'IngredientDragDrop',
		components: {
			SlickList,
			SlickItem,
		},
		props: {
			appendTo: {
				type: String,
				default: '',
			},
			helperClass: {
				type: String,
				default: '',
			},
			list: {
				type: Array,
				default: () => [],
			},
		},
		data() {
			return {
				selectedModel: [],
			};
		},
		watch: {
			list(list) {
				this.selectedModel = list;
			},
		},
		methods: {
			deleteItem(targetItem) {
				this.selectedModel = this.selectedModel.filter(
					item => item.id !== targetItem.id
				);
				this.$emit('change', this.selectedModel);
			},
		},
		mounted() {
			this.selectedModel = this.list;
		},
	};
</script>
<style lang="scss" scoped>
	.drag-drop {
		height: 511px;
		background: #dfe6ee;
		border-radius: 4px;
		border: solid 1px #dfe6ee;

		&__list {
			overflow-x: hidden;
			overflow-y: auto;
			width: 100%;
			height: 100%;
		}

		&__item {
			position: relative;
			width: 100%;
			padding: 4px 30px 4px 8px;
			background: white;
			white-space: nowrap;
			border-bottom: solid 1px #dfe6ee;
		}

		&__item-name {
			overflow: hidden;
			display: block;
			width: 100%;
			height: 22px;
			line-height: 22px;
			text-overflow: ellipsis;
		}

		&__delete-button {
			position: absolute;
			display: block;
			height: auto;
			top: 4px;
			right: 4px;
			padding: 0 5px;
			line-height: 20px;
		}

		&__noitem {
			display: flex;
			width: 100%;
			height: 100%;
			background: white;
			border-radius: 4px;
			padding: 20px;
			line-height: 27px;
			align-items: center;
			justify-content: center;
			word-break: keep-all;
		}
	}
</style>
